import authProvider from '@/utility/authProvider';
import { AuthActionTypes } from '@/store/modules/auth/action.type';
import { CommonActionType } from '@/store/modules/common/action.type';
import { CartActionType } from '@/store/modules/cart/action.type'

import { APP_CONFIG } from '@/config/app-config';

export default [
    {
        name: 'APP_LOGIN_SUCCESS',
        callback: function(data, isRoute = false) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.authStore}/${AuthActionTypes.SetUserInfo}`, { 
                email: data.user.email,
                userId: data.user.userid,
                userName: data.user.username,
                userCode: data.user.usercode
            });

            authProvider.setToken(data.token);
            if (!isRoute) {
                this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.ShowHideMenuLeft}`, screen.width > 760);
                this.$router.push({ name: 'credit' });
            }
        },
    },
    {
        name: 'APP_SET_CUSTOMER_INFO',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.authStore}/${AuthActionTypes.SetCustomerInfo}`, data);
        }
    },
    {
        name: 'APP_REGISTER_SUCCESS',
        callback: function(data) {
            if (data) {
                this.$router.push({ name: 'notify-type', params: { type: data } });
            } else {
                this.$router.push({ name: 'notify' });
            }
        },
    },
    {
        name: 'APP_LOGOUT',
        callback: function() {
            this.$store.dispatch(`${APP_CONFIG.stateKey.authStore}/${AuthActionTypes.LogOut}`);
            this.$store.dispatch(`${APP_CONFIG.stateKey.cartState}/${CartActionType.SelectedCart}`, null);
            authProvider.removeToken();
            this.$router.push({ name: 'login' });
        },
    },
    {
        name: 'SET_RATE',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetExchangeRate}`, data);
        },
    },
    {
        name: 'SET_MIN_FEEBUY',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetMinFeeBuy}`, data);
        },
    },
    {
        name: 'SET_FEE_BUY_PRO',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.FeeBuyPro}`, data);
        },
    },
    {
        name: 'SET_CUSTOMER_LEVELS',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetCustomerLevels}`, data);
        },
    },
    {
        name: 'SET_WAREHOUSE',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetWarehouse}`, data);
        },
    },
    {
        name: 'SET_CHINASTORE',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetChinaStore}`, data);
        },
    },
    {
        name: 'SET_FEEGUARANTEE',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.SetFeeGuarantee}`, data);
        },
    },
    {
        name: 'SET_SELECTED_CART',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.cartState}/${CartActionType.SelectedCart}`, data);
        }
    },
    {
        name: 'SHOW_HIDE_MENU_LEFT',
        callback: function(data) {
            this.$store.dispatch(`${APP_CONFIG.stateKey.commonStore}/${CommonActionType.ShowHideMenuLeft}`, data);
        }
    }
];
